export const organizationDetailsStyle = {
  wrapper: {
    // width: '100%',
    // maxWidth: '970px',
    // height: '100%',
    // // height: '1170px',
    // overflowY: 'auto',
    width: '100%',
    maxWidth: '970px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
  },

  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    alignItems: 'center',
    marginBottom: '24px',

    '& .MuiTypography-body1': {
      color: 'var(--neutral-300)',
    },
  },

  tabs: {
    background: 'var(--default-white)',
    padding: '24px 0',
    maxHeight: '36px',
    borderRadius: '8px 8px 0 0',
    marginBottom: '24px',
  },

  tab: {
    maxWidth: '315px',
    width: '100%',
    zIndex: 99,
  },

  logo: {
    '& img': {
      width: '100px',
      height: '100px',
      borderRadius: '50%',
      border: '1px solid var(--neutral-100)',
    },
    marginBottom: '12px',
  },

  tabContent: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
  },
};
